export const initShare = () => {
	const shareWrapper = document.querySelector( 'div.share' );
    const urlLink = window.location.href;

    const inputUrl = document.querySelector('.likely>.copy>span');

    if ( !inputUrl ) {
        return;
    } else {
        inputUrl.innerHTML = urlLink;
    }

	if ( !shareWrapper )
	{
		return;
	}
	
	const shareCheck = shareWrapper.querySelector( 'input' );

	if ( !shareCheck )
	{
		return;
	}

	document.addEventListener( 'click', ( {target} ) => {
		if ( shareCheck.checked && !target.closest( 'div.share' ) )
		{
			shareCheck.checked = false;
		}
	} );
};
